import api from "@/http/api";
import { useQuery } from "@tanstack/react-query";
import ProductShareView, {
    type ShareConfigItem,
} from "@univdiam/ui/customComponents/CatalogProduct/ProductShareView";
import { prettyLabel } from "@univdiam/ui/lib/prettyLabel";
import { useNavigate, useSearchParams } from "react-router-dom";

const getProduct = (id: string) => {
    return api.get(`/cad/cad/${id}`);
};

type QueryData = Record<string, string>;

const SubmittedProduct = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const queryData = JSON.parse(searchParams.get("d")!) as QueryData;
    const BOM = JSON.parse(queryData.bom!);

    const { data } = useQuery({
        queryKey: ["product-share-cad", queryData.cad_design_id],
        queryFn: async () => getProduct(queryData.cad_design_id!),
        enabled: !!queryData.cad_design_id,
    });

    const selectedProduct = data?.data?.data;

    const config: ShareConfigItem[] = Object.entries(BOM)
        .filter(([key]) => !["title", "id", "price"].includes(key))
        .map(([key, value]) => ({
            label: prettyLabel(key),
            value: String(value),
        }));
    return (
        <ProductShareView
            images={selectedProduct?.attachments ?? []}
            iframeLink={selectedProduct?.iframe_link}
            title={BOM?.title}
            price={Number(BOM.price)}
            config={config}
            instructions={queryData.instructions}
            onBack={() => navigate(-1)}
            customFields={selectedProduct?.customFields}
            productID={queryData?.productId}
        />
    );
};

export default SubmittedProduct;
